// store
import * as SettlementStore from '../../../../redux/middleware/SettlementMiddleware';

// models
import { Settlement } from '../../../../models/Entities/Settlements/Settlement';
import { ErrorType } from '../../../../models/HttpError';
import { AppState } from '../../../../redux/reducers';

interface IProps {
    protocolId: number;
    selectionLimit?: number;
    selectedSettlements?: Settlement[];
    onChangeSelection?: (selectedSettlements: Settlement[] | undefined) => void;
}

interface ConnectedProps {
    isLoading: boolean;
    isLoadingSuccess: boolean | undefined;
    failOnLoading: boolean;
    error: ErrorType | undefined;
    Settlements: Settlement[];
}

interface DispatchProps {
    GetSettlementsByProtocolId: typeof SettlementStore.actionCreators.GetSettlementsByProtocolId;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    isLoading: state.Settlement?.isLoadingByProtocol,
    isLoadingSuccess: state.Settlement?.isLoadingByProtocolSuccess,
    failOnLoading: state.Settlement?.FailLoadingByProtocol,
    error: state.Settlement?.error,
    Settlements: state.Settlement?.settlementsByProtocol ?? [],
});

export const mapDispatchToProps = ({
    ...SettlementStore.actionCreators
});
